<template>
  <div class="mb-12" :class="$vuetify.breakpoint.name === 'lg' ? 'pr-12 pl-8' : 'px-3'">
    <v-dialog
      v-model="dialog"
      persistent
      width="350">
      <v-card class="pa-4">
        <v-card-text class="body-2 pt-3 pb-1">
          Apakah Anda yakin untuk <span v-if="detail.invoiceStatus === 'confirmed'">Megkonfirmasi</span> <span v-if="detail.invoiceStatus === 'ok'">Menunda</span> pembayaran ini ?
        </v-card-text>
        <v-card-actions class="mt-5">
          <v-spacer></v-spacer>
          <v-btn
            rounded
            small
            width="100"
            color="#3a3a3a"
            elevation="0"
            :disabled="process.status"
            :loading="process.status"
            class="white--text text-capitalize"
            @click="save">
            Yakin
          </v-btn>
          <v-btn
            rounded
            small
            width="100"
            elevation="0"
            class="text-capitalize"
            :disabled="process.status"
            @click="dialog = false">
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-breadcrumbs 
      :items="breadcrumbs" 
      divider=">"
      class="pa-1">
    </v-breadcrumbs>

    <div>
      <v-row justify="center" v-if="process.run">
        <v-col :cols="$vuetify.breakpoint.name === 'xs' ? '6' : '3' ">
          <div
            class="text-center" 
            style="padding-top: 12rem; padding-bottom: 12rem; height:535px;">
            <p class="title mt-8 mb-5 pink--text">
              Menunggu data . . .
            </p>
            <v-progress-linear
              color="#ff618a"
              indeterminate
              rounded
              height="6">
            </v-progress-linear>
          </div>
        </v-col>
      </v-row>

      <v-row class="align-start" v-if="!process.run && Object.keys(detail).length > 0">
        <v-col cols="12">
          <v-card
            class="ma-auto px-3"
            color="#333333"
            tile
            flat>
            <v-card-title class="body-1 font-weight-bold white--text">
              {{ detail.invoiceCode }}
              <v-spacer></v-spacer>
              <span class="caption font-weight-bold">
                Pembelian Kelas
              </span>
            </v-card-title>
            <v-card-subtitle class="white--text text-capitalize">
              {{ detail.invoiceMethod }}
              <v-spacer></v-spacer>
            </v-card-subtitle>
            <v-card-text class="display-1 white--text pt-0 pb-0">
              <span v-if="detail.invoiceTotalPrice === 0">
                Gratis
              </span>
              <span v-if="detail.invoiceTotalPrice > 0">
                {{ detail.invoiceTotalPrice | price }}
              </span>
            </v-card-text>
            <div class="d-flex">
              <div>
                <v-card-text class="white--text pt-2">
                  <span v-if="detail.invoiceStatus === 'ok'" class="font-weight-bold green--text">
                    Ok
                  </span>
                  <span v-if="detail.invoiceStatus === 'pending'" class="font-weight-bold grey--text text--darken-2">
                    Pending
                  </span>
                  <span v-if="detail.invoiceStatus === 'confirmed'" class="font-weight-bold pink--text">
                    Menunggu Konfirmasi
                  </span>
                  <span v-if="detail.invoiceStatus === 'failed'" class="font-weight-bold red--text">
                    Pembelian Gagal
                  </span>
                </v-card-text>
              </div>
              <div class="ml-auto">
                <v-btn 
                  v-if="detail.invoiceStatus === 'confirmed'"
                  rounded
                  dense
                  color="#ff618a"
                  class="text-capitalize mr-2"
                  dark
                  small
                  elevation="0"
                  light
                  @click="dialog = true">
                  Konfirmasi Sekarang
                </v-btn>
              </div>
            </div>
          </v-card>

          <v-card
            class="ma-auto px-1"
            flat>
            <v-list-item two-line class="pa-0">
              <v-list-item-content>
                <v-card-title class="body-1">
                  {{ detail.invoiceDate | datetime }}
                </v-card-title>
                <v-card-subtitle>
                  Transaksi
                </v-card-subtitle>
              </v-list-item-content>
              <v-list-item-content class="text-center">
                <v-card-title class="body-1 justify-center">
                  {{ detail.invoiceDueDate | datetime }}
                </v-card-title>
                <v-card-subtitle>
                  Terakhir Pembayaran
                </v-card-subtitle>
              </v-list-item-content>
              <v-list-item-content class="text-right">
                <v-card-title class="body-1 justify-end">
                  {{ detail.invoiceBankConfirmDatetime | datetime }}
                </v-card-title>
                <v-card-subtitle>
                  Konfirmasi Pembayaran
                </v-card-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mb-5"></v-divider>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text--secondary text-left">Produk</th>
                    <th class="text--secondary text-right">Harga</th>
                    <th class="text--secondary text-right">Diskon</th>
                    <th class="text--secondary text-right">Potongan</th>
                    <th class="text--secondary text-right">Sub Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(l, index) in detail.invoiceProduct"
                    :key="index"
                    class="text--secondary">
                    <td>
                      <v-list-item class="px-0">
                        <v-list-item-content>
                          <v-list-item-title class="body-2 font-weight-bold text--secondary">
                            {{ l.cartProductTitle }}
                          </v-list-item-title>
                          <v-list-item-subtitle class="caption mt-1 text--secondary">
                            {{ l.cartCategoryTitle }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </td>
                    <td class="text-right">{{ l.cartPriceProduct | price }}</td>
                    <td class="text-right">
                      <span v-if="l.cartDiscountPercent < 1">
                        -
                      </span>
                      <span v-else>
                        {{ l.cartDiscountPercent }}%
                      </span>
                    </td>
                    <td class="text-right">
                      <span v-if="l.cartDiscountPercent < 1">
                        -
                      </span>
                      <span v-else>
                        {{ l.cartPriceProduct - l.cartTotalPrice | price }}
                      </span>
                    </td>
                    <td class="text-right">{{ l.cartTotalPrice | price }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-divider></v-divider>
            <div class="d-flex body-2 text--secondary font-weight-bold mt-3 px-4 mb-0">
              Total
              <div class="text-right ml-auto">
                {{ detail.invoiceTotalPrice | price }}
              </div>
            </div>
            <v-divider class="mt-5" v-if="detail.invoiceStatus !== 'pending' && detail.invoiceTotalPrice > 0"></v-divider>
            <v-row v-if="detail.invoiceStatus !== 'pending' && detail.invoiceTotalPrice > 0">
              <v-col
                cols="12"
                sm="6">
                <v-card-title class="body-1 text--secondary font-weight-bold">
                  Bank Pengirim
                </v-card-title>
                <v-card-subtitle class="pb-0 text--secondary">
                  Silahkan transfer ke bank yang kami sediakan
                </v-card-subtitle>
                <v-list-item two-line>
                  <v-img
                    height="40"
                    max-width="40"
                    contain
                    :src="detail.invoiceBankUrlImage">
                  </v-img>
                  <v-list-item-content>
                    <v-card-title class="body-2 pt-0 text--secondary">
                      {{ detail.invoiceUserName }} - {{ detail.invoiceBankName }} 
                    </v-card-title>
                    <v-card-subtitle class="caption pb-0 text--secondary">
                      {{ detail.invoiceBankSenderAccountNumber }}
                    </v-card-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                sm="6">
                <v-card-title class="body-1 text--secondary font-weight-bold">
                  Bank Penerima
                </v-card-title>
                <v-card-subtitle class="pb-0 text--secondary">
                  Silahkan transfer ke bank yang kami sediakan
                </v-card-subtitle>
                <v-list-item two-line>
                  <v-img
                    height="40"
                    max-width="40"
                    contain
                    :src="detail.bankDestination.bankLogo">
                  </v-img>
                  <v-list-item-content>
                    <v-card-title class="body-2 pt-0 text--secondary">
                      Cendekia - {{ detail.bankDestination.bankName }} 
                    </v-card-title>
                    <v-card-subtitle class="caption pb-0 text--secondary">
                      {{ detail.invoiceBankDestinationAccountNumber }}
                    </v-card-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col
                cols="12"
                sm="6">
                <v-card-title class="body-1 font-weight-bold text--secondary">
                  Bukti Pembayaran
                </v-card-title>
                <v-img width="200" height="200" class="mx-4" :src="detail.invoiceProofOfPaymentUrl"></v-img>
              </v-col>
              <v-col
                cols="12"
                sm="6">
                <v-card-title class="body-1 font-weight-bold text--secondary">
                  Catatan
                </v-card-title>
                <v-card-subtitle class="pb-0 text--secondary">
                  {{ detail.invoiceNote }}
                </v-card-subtitle>
              </v-col>
            </v-row>
          </v-card>

          <v-expand-transition>
            <v-card
              class="v-buy mt-3"
              color="#333333"
              flat
              style="border-radius: 0px;">
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title 
                    class="title white--text">
                    <span v-if="detail.invoiceTotalPrice === 0">
                      Gratis
                    </span>
                    <span v-if="detail.invoiceTotalPrice > 0">
                      {{ detail.invoiceTotalPrice | price }}
                    </span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-btn
                  color="text-capitalize"
                  style="color: #333333;"
                  elevation="0"
                  :to="`/transaction/selling`">
                  Riwayat Pembelian
                </v-btn>
              </v-list-item>
            </v-card>
          </v-expand-transition>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../../../service/Axios";
  export default {
    data () {
      return {
        dialog: false,
        breadcrumbs: [                                             
          {
            text: 'Penjualan',
            disabled: false,
            href: '/transaction/selling',
          },
          {
            text: 'Detail Penjualan',
            disabled: true,
            href: '#',
          }
        ],
        detail: {},
        process: {
          run: false,
          status: false
        },
        response: ''
      }
    },
    mounted() {
      this.fetch()
    },
    methods: { 
      async fetch() {
        this.process.run = true
        await get(`api/internal/invoice/detail/${this.$route.params.id}`)
        .then((response) => {
          let res = response.data
          if (res.code === 200) {
            this.process.run = false
            this.detail = res.data
          }
        })
      },
      async save() {
        this.process.status = true
        await put(`api/internal/invoice/update/status/${this.detail.id}`, {
          data: {
            status: 'ok', 
          }
        })
        .then((response) => {
          if (response.data.code === 201) {
            this.process.status = false
            this.dialog = false
            this.fetch()
          }
        })
      }
    }
  }
</script>